import { Card, CardContent, CardHeader, CardTitle, Input, Switch, Textarea } from '@ibsys/kit';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AttributeFormValues } from '../validation';
import { StructureAttributesList } from './StructureAttributesList';
import { StructureGroupsList } from './StructureGroupsList';

type Props = {
  disabled?: boolean;
};

export const StructureForm: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation(['attributes', 'common']);
  const { control, watch } = useFormContext<AttributeFormValues>();

  const structure = watch('structure');
  const isSelect = structure?.isSelect ?? false;

  return (
    <Card className="w-full border">
      <CardHeader>
        <CardTitle>{t('attributes:structure')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            control={control}
            name="structure.code"
            label={t('attributes:structureCode')}
            required
            disabled={disabled}
            placeholder="ADDRESS"
          />
          <Input
            control={control}
            name="structure.name"
            label={t('attributes:structureName')}
            required
            disabled={disabled}
          />
        </div>

        <Textarea
          control={control}
          name="structure.description"
          label={t('attributes:description')}
          rows={3}
          disabled={disabled}
        />

        <Switch control={control} name="structure.isSelect" label={t('attributes:isSelect')} disabled={disabled} />

        <StructureAttributesList disabled={disabled} />

        {isSelect && <StructureGroupsList disabled={disabled} />}
      </CardContent>
    </Card>
  );
};
